// extracted by mini-css-extract-plugin
module.exports = {"nav":"WrapperStation_nav__Dr-vL","desktop":"WrapperStation_desktop__2VXQ1"};